import { ACTION_PRE, ACT_USER_INFO, SET_USER_INFO } from './constants'
import { goApp, login } from '@/utils/common'
import { getUserInfo } from '@/api/http'

export default {
  async [ACT_USER_INFO]({ commit }: { commit: any }) {
    try {
      const info = await getUserInfo()
      commit(SET_USER_INFO, info)
      return true
    } catch (err) {
      return false
    }
  },

  [ACTION_PRE](context: { state: any }, isGoApp = true) {
    return new Promise((res, rej) => {
      if (isGoApp && goApp()) {
        rej()
        return
      }
      const { userInfo } = context.state
      if (userInfo && userInfo.isLogin) {
        res(null)
      } else {
        login(() => {
          window.location.reload()
        })
        rej()
      }
    })
  },
}
